module.exports = __webpack_public_path__ + "static/media/KOTAKBANK.1ce43d70.txt";